export default {
  specialization: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/components/specializations/resources/props.js